import type { Plugin } from '@puckeditor/core';
import { use, createContext } from 'react';
import type { MicrositeListingData } from '~/model';
import { DEMO_LISTING_DATA } from '~/demo';

export type MicrositeListingContext = MicrositeListingData & {
	beds_locale?: string;
	baths_locale?: string;
	sqft_locale?: string;
	lot_locale?: string;
	lot_acres_locale?: string;
};

const LOCALE_NUMBER_KEYS = ['beds', 'baths', 'sqft', 'lot', 'lot_acres'] as const;

function formatListingLocaleValue(value?: number) {
	if (value === undefined || value === null) {
		return undefined;
	}

	if (Number.isInteger(value)) {
		return value.toLocaleString();
	}

	return value.toLocaleString(undefined, { maximumFractionDigits: 1 });
}

export function withListingLocaleFields(listing: MicrositeListingData): MicrositeListingContext {
	const localized = { ...listing } as MicrositeListingContext;

	LOCALE_NUMBER_KEYS.forEach((key) => {
		localized[`${key}_locale`] = formatListingLocaleValue(listing[key]);
	});

	return localized;
}

const ListingContext = createContext<MicrositeListingContext>(withListingLocaleFields(DEMO_LISTING_DATA));

export function useListingContext() {
	return use(ListingContext);
}

export const ListingPlugin: Plugin = {
	name: 'photology-listing',
	label: 'Listing',
	icon: <></>,
	render: () => <div>My plugin UI</div>, // Component rendered in plugin panel
};
